module.exports = __webpack_public_path__ + "static/img/10.bc16f9ad.png";